import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/Logo_Horizontal_Full.png';
import { COMPANY, CONTACT_EMAIL } from './landingFacts';

const Arrow = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 18 18 6M6 6h12v12" /></svg>;

/** Footer of the public pages, with the company data required on an Italian business website. */
export default function PublicFooter({ backToTop = false }: { backToTop?: boolean }) {
    return <footer className="sp-footer">
        <div className="sp-footer__top">
            <Link to="/" aria-label="Semplora, homepage">
                <img src={logo} alt="Semplora" width="180" height="60" />
            </Link>
            <span>Costruito da chi conosce il tuo lavoro.</span>
            <a href={`mailto:${CONTACT_EMAIL}`}>Scrivici a {CONTACT_EMAIL} <Arrow />
            </a>
        </div>
        <div className="sp-footer__bottom">
            <span>© {new Date().getFullYear()} {COMPANY.name} · {COMPANY.address} · P.IVA&nbsp;{COMPANY.vatNumber} · R.E.A.&nbsp;n.&nbsp;{COMPANY.rea} · Capitale sociale {COMPANY.shareCapital}</span>
            <div>
                <Link to="/privacy">Privacy</Link>
                <Link to="/cookie">Cookie</Link>
                <Link to="/termini">Termini</Link>
                <Link to="/login">Accedi</Link>
            </div>
            {backToTop && <a href="#contenuto" aria-label="Torna all’inizio della pagina">TORNA SU ↑</a>}
        </div>
    </footer>;
}
